// MRVendorsModal.js
import React, { useState, useMemo } from "react";

const MRVendorsModal = ({ isOpen, onClose, allVendors = [], assignedVendorIds = [], MRNumber, onSave }) => {
  const [selectedVendorId, setSelectedVendorId] = useState(
  assignedVendorIds[0] || (allVendors[0]?._id ?? null)
);
  const [localAssigned, setLocalAssigned] = useState(new Set(assignedVendorIds));
  const [search, setSearch] = useState("");
//console.log("assignedVendorIds:", assignedVendorIds);
//console.log("localAssigned:", localAssigned);
  const filteredVendors = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return allVendors;
    return allVendors.filter(v => (
      (v.name || "").toLowerCase().includes(q) ||
      (v.company_name || "").toLowerCase().includes(q) ||
      (v.email || "").toLowerCase().includes(q)
    ));
  }, [allVendors, search]);

  const toggleAssign = (vendorId) => {
    setLocalAssigned(prev => {
      const copy = new Set(prev);
      if (copy.has(vendorId)) copy.delete(vendorId);
      else copy.add(vendorId);
      return copy;
    });
  };

  const handleSave = () => {
    onSave(Array.from(localAssigned));
  };

  const selectedVendor = allVendors.find(v => v._id === selectedVendorId) || null;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-[80vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div>
            <h3 className="text-lg font-semibold">Manage Vendors — {MRNumber}</h3>
            <p className="text-sm text-gray-500">Assign or remove vendors for this MR</p>
          </div>
          <div className="flex gap-2 items-center">
            <button onClick={onClose} className="text-sm text-gray-600 px-3 py-1 rounded hover:bg-gray-50">Close</button>
            <button onClick={handleSave} className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700">Save</button>
          </div>
        </div>

        {/* Body: left list, right details */}
        <div className="flex-1 flex overflow-hidden">
          {/* Left: vendor list */}
          <div className="w-1/2 border-r overflow-y-auto p-4">
            <div className="mb-3">
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search vendors..."
                className="w-full px-3 py-2 border rounded-md focus:outline-none"
              />
            </div>

            <div className="space-y-2">
              {filteredVendors.length === 0 && <div className="text-gray-500">No vendors found.</div>}
              {filteredVendors.map(v => {
                const isAssigned = localAssigned.has(v._id);
                return (
                  <div
                    key={v.id}
                    onClick={() => setSelectedVendorId(v._id)}
                    className={`flex items-center justify-between p-3 rounded cursor-pointer border ${selectedVendorId === v._id ? "bg-gray-50 border-gray-300" : "hover:bg-gray-50"}`}
                  >
                    <div className="min-w-0">
                      <div className="font-medium text-gray-800 truncate">{v.name}</div>
                      <div className="text-xs text-gray-500 truncate">{v.company_name}</div>
                      <div className="text-xs text-gray-400">{v.email}</div>
                    </div>

                    <div className="flex flex-col items-end gap-2">
                      <div className={`text-xs font-medium px-2 py-0.5 rounded ${isAssigned ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                        {isAssigned ? 'Assigned' : 'Not assigned'}
                      </div>
                      <button
                        onClick={(e) => { e.stopPropagation(); toggleAssign(v._id); }}
                        className={`text-xs px-2 py-1 rounded ${isAssigned ? 'bg-red-600 text-white' : 'bg-blue-600 text-white'}`}
                      >
                        {isAssigned ? 'Unassign' : 'Assign'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right: vendor details */}
          <div className="flex-1 p-4 overflow-y-auto">
            {selectedVendor ? (
              <div>
                <h4 className="text-lg font-semibold">{selectedVendor.name}</h4>
                <p className="text-sm text-gray-600">{selectedVendor.company_name}</p>

                <div className="mt-4 space-y-2 text-sm text-gray-700">
                  <div><span className="text-gray-400">Email:</span> {selectedVendor.email}</div>
                  <div><span className="text-gray-400">Phone:</span> {selectedVendor.mobile_number}</div>
                  <div><span className="text-gray-400">Address:</span> {selectedVendor.address}</div>
                  <div><span className="text-gray-400">Rating:</span> {selectedVendor.rating}</div>
                  {selectedVendor.notes && <div><span className="text-gray-400">Notes:</span> {selectedVendor.notes}</div>}
                </div>

                <div className="mt-6 flex items-center gap-3">
                  <button
                    onClick={() => toggleAssign(selectedVendor._id)}
                    className={`px-3 py-1 rounded ${localAssigned.has(selectedVendor._id) ? 'bg-red-600 text-white' : 'bg-blue-600 text-white'}`}
                  >
                    {localAssigned.has(selectedVendor._id) ? 'Unassign' : 'Assign'}
                  </button>

                  <button
                    onClick={() => alert('Open vendor profile / history - implement as needed')}
                    className="px-3 py-1 rounded border"
                  >
                    View profile
                  </button>
                </div>

              </div>
            ) : (
              <div className="text-gray-500">Select a vendor on the left to view details</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MRVendorsModal;
